import { Modal } from '@betty/navigation';
import { AsyncStorage } from '@betty/toolkit/storage';
import { getCookie } from '@betty/toolkit/utils';
import { useEffect, useMemo, useState } from 'react';

export const LOCATION_REDIRECT_COOKIE_NAME = 'betty-location-redirect';
export const REDIRECT_SUGGESTION_BETTY_ONTARIO_SELECTED_SESSION_STORAGE_KEY =
  'redirect_suggestion_betty_ontario_selected';
export const REDIRECT_SUGGESTION_DELAY = 2000;

export const BETTY_COM_REGISTER_URL = 'https://betty.com/register';
export const BETTY_COM_UTM_VARIANT = 'betty.ca';
export const BETTY_COM_MS_CLICK_ID = 'msclkid';

export const useRedirectSuggestion = () => {
  const redirectLocationCookie = getCookie(LOCATION_REDIRECT_COOKIE_NAME);

  const [isStayOnBettyOntarioSelected, setIsStayOnBettyOntarioSelected] =
    useState<string | undefined>(undefined);

  useEffect(() => {
    const getIsStayOnBettyOntarioSelected = async (): Promise<void> => {
      const result = await AsyncStorage.getItem(
        REDIRECT_SUGGESTION_BETTY_ONTARIO_SELECTED_SESSION_STORAGE_KEY,
      );

      setIsStayOnBettyOntarioSelected(result);
    };

    getIsStayOnBettyOntarioSelected();
  }, []);

  const shouldShowRedirectSuggestion = useMemo(
    () => redirectLocationCookie && !isStayOnBettyOntarioSelected,
    [redirectLocationCookie, isStayOnBettyOntarioSelected],
  );

  useEffect(() => {
    if (shouldShowRedirectSuggestion) {
      const delayedRedirectModalOpen = setTimeout(() => {
        Modal.open({
          namespace: 'registration',
          type: 'RedirectSuggestionModal',
          options: {
            hideHeader: true,
            variant: 'default',
          },
          canClose: false,
          style: {
            width: {
              mobile: '90%',
              tablet: 480,
              desktop: 480,
            },
            height: {
              mobile: 'auto',
              tablet: 'auto',
              desktop: 'auto',
            },
            paddingTop: 'space-200',
            backgroundColor: 'screenBackground',
          },
        });
      }, REDIRECT_SUGGESTION_DELAY);

      return () => clearTimeout(delayedRedirectModalOpen);
    }
  }, [shouldShowRedirectSuggestion]);
};
